import { faPencil } from '@fortawesome/pro-light-svg-icons';
import { IconLinkButton } from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { Team, TeamRole } from '@foxtrotplatform/platform-micro-site-core';
import { TableCell, TableRow } from '@windmill/react-ui';
import { FunctionComponent, useCallback } from 'react';

import { RoleTypeComponent } from './HelperComponents';

export interface UserTeamProps {
  team: Team;
  redirectToTeamManagement: (id: string) => void;
}

export const UserTeamComponent: FunctionComponent<UserTeamProps> = ({
  team,
  redirectToTeamManagement,
}): JSX.Element | null => {
  const TeamButtons = useCallback(() => {
    if (team.role === TeamRole.DEVELOPER_TEAM_ADMIN) {
      return (
        <TableCell className="flex gap-x-3">
          <IconLinkButton
            icon={faPencil}
            linkText="Edit"
            onClick={() => redirectToTeamManagement(team.id)}
          />
        </TableCell>
      );
    }

    return null;
  }, [team.id]);

  return (
    <TableRow>
      <TableCell className="w-3/5">
        <span>{team.name}</span>
      </TableCell>
      <TableCell className="w-1/3">
        <RoleTypeComponent role={team.role} />
      </TableCell>
      <TeamButtons />
    </TableRow>
  );
};
